export const SAVE_CHANNEL_DATA_REQUEST = 'SAVE_CHANNEL_DATA_REQUEST';
export const SAVE_CHANNEL_DATA_SUCCESS = 'SAVE_CHANNEL_DATA_SUCCESS';
export const SAVE_CHANNEL_DATA_FAILURE = 'SAVE_CHANNEL_DATA_FAILURE';
export const SAVE_CHANNEL_DATA_RESET = 'SAVE_CHANNEL_DATA_RESET';
// Save data actions
export const saveChannelDataRequest = (payload) => ({
    type: SAVE_CHANNEL_DATA_REQUEST,
    payload
});
export const saveChannelDataSuccess = (payload) => ({
    type: SAVE_CHANNEL_DATA_SUCCESS,
    payload,
});
export const saveChannelDataFailure = (error) => ({
    type: SAVE_CHANNEL_DATA_FAILURE,
    payload: error,
});
export const saveChannelDataReset = () => ({
    type: SAVE_CHANNEL_DATA_RESET,
});
